import { helpers, required, numeric } from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';
import dayjs from 'dayjs';

const endDateIsAfterStartDate = helpers.withParams(
    { type: 'endDateIsAfterStartDate' },
    function() {
        return !dayjs(this.formData.endDate).isBefore(this.formData.startDate);
    }
);

export default {
    mixins: [abstractValidatorMixin],
    data() {
        return {
            serverErrors: {
                userId: [],
                position: [],
                startDate: [],
                endDate: [],
                duration: [],
                daysOff: []
            }
        };
    },
    validations: {
        formData: {
            userId: { required },
            position: { required },
            startDate: { required },
            endDate: { required, endDateIsAfterStartDate },
            duration: { numeric, required },
            daysOff: { required }
        }
    },
    computed: {
        userIdErrors() {
            return this.checkErrors('userId');
        },
        positionErrors() {
            return this.checkErrors('position');
        },
        startDateErrors() {
            return this.checkErrors('startDate');
        },
        endDateErrors() {
            return this.checkErrors('endDate');
        },
        durationErrors() {
            return this.checkErrors('duration');
        },
        daysOffErrors() {
            return this.checkErrors('daysOff');
        }
    }
};
